// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"79":"6af2c055","126":"8e317a0e","264":"365fe872","745":"b85aab17","966":"9a48f803"}[chunkId] + ".js";
};